// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_parking_boundaries: MapboxStyleLayer[] = [
  {
    type: 'line',
    id: 'line-border-1',
    paint: {
      'line-color': '#664100',
      'line-opacity': 0.63,
      'line-width': 3,
    },
  },
  {
    type: 'line',
    id: 'line-border-1 copy',
    paint: {
      'line-color': '#664100',
      'line-opacity': 0.3,
      'line-width': 4,
      'line-offset': 4,
    },
  },
  {
    layout: {
      'text-field': ['to-string', ['get', 'name']],
      'symbol-placement': 'line-center',
      'text-size': 14,
      'text-offset': [0, 0.7],
      'text-justify': 'auto',
      'text-allow-overlap': true,
      'symbol-avoid-edges': true,
      'text-padding': 0,
    },
    type: 'symbol',
    id: 'label copy 1',
    paint: {
      'text-color': '#fffbeb',
      'text-halo-width': 3,
      'text-halo-color': 'rgba(102, 65, 0, 0.65)',
      'text-halo-blur': 1,
    },
  },
]
